import React from "react";
import { Container } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import StepForm1 from "./organizesteps/StepForm1";
import StepForm2 from "./organizesteps/StepForm2";
import StepForm3 from "./organizesteps/StepForm3";
import { useMobileVerifyContext } from "provider/MobileVerificationProvider";

const MobileNoVerificationModal = ({handleSubmit}) => {
  const { toggleMobileVerify, step, mobileVerifyDispatch } = useMobileVerifyContext();
  const maxSteps = 3;

  const handleClose = () => {
    mobileVerifyDispatch({ type: "MOBILE_VERIFY_TOGGLE", payload: false });
  };

  const renderStepForm = () => {
    switch (step) {
      case 1:
        return <StepForm1 />;
      case 2:
        return <StepForm2 />;
      case 3:
        return <StepForm3 handleSubmit ={handleSubmit}/>;
      default:
        return null;
    }
  };

  return (
    <Modal show={toggleMobileVerify} onHide={handleClose} centered  backdrop="static" dialogClassName="custom-modal-size">
      <Modal.Header className="justify-content-center" closeButton>
        <p className="modal-title fs-5 p-0 fw-semibold">Mobile Number Verification</p>
      </Modal.Header>

      <Modal.Body className="px-3 pt-0">
        <div className="py-3 px-2">
          <Container fluid="lg">
            {renderStepForm()}

            <div className="dots-container text-center mt-3">
              {[...Array(maxSteps).keys()].map((index) => {
                const dotStep = index + 1;
                return (
                  <span
                    key={dotStep}
                    className={`dot ${step === dotStep ? "active" : ""}`}
                    onClick={() => {
                      if (dotStep <= step) {
                        mobileVerifyDispatch({
                          type: "MOBILE_VERIFY_SET_STEP",
                          payload: dotStep,
                        });
                      }
                    }}
                  />
                );
              })}
            </div>
          </Container>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default MobileNoVerificationModal;
